import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Picture } from '@components/ui/Picture/Picture';

import css from './styles.module.scss';

import blureBannerPng from '/img/contract-lock-img/banner-background-lock.png';
import blureBannerWebp from '/img/contract-lock-img/banner-background-lock.webp';
import lockPng from '/img/contract-lock-img/contract-lock.png';
import lockWebp from '/img/contract-lock-img/contract-lock.webp';
import contractCharacterPng from '/img/contract-lock-img/contracts-girl.png';
import contractCharacterWebp from '/img/contract-lock-img/contracts-girl.webp';
import HummerPng from '/img/contract-lock-img/Hummer.png';
import HummerWebp from '/img/contract-lock-img/Hummer.webp';
import lockSvg from '/img/icons/lock-icon.svg';

interface ContractsLockProps {
  minLevel: number;
}

const ContractsLock: FC<ContractsLockProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="px-4 w-full">
      <div className="w-full aspect-[99/63] relative">
        <Picture
          img={lockPng}
          webp={lockWebp}
          className={css.picture}
          style={{ zIndex: '-1' }}
          alt="contracts lock"
        />
        <Picture
          img={blureBannerPng}
          webp={blureBannerWebp}
          className={css.picture}
          style={{ zIndex: '-2' }}
          alt="banner lock"
        />
        <picture>
          <source srcSet={contractCharacterWebp} type="image/webp" />
          <img
            className="character-lock-banner"
            src={contractCharacterPng}
            alt="contract character"
          />
        </picture>
        <div className="block-lock-banner">
          <div className="requirment-lock-banner">
            <img src={lockSvg} width={32} alt="lock" />
            <p className="text-lock-banner">
              {t('Requirements to unlock Contracts')}
            </p>
          </div>
          <div className="build-lock-banner">
            <picture>
              <source srcSet={HummerWebp} type="image/webp" />
              <img src={HummerPng} width={48} alt="contract character" />
            </picture>
            <div>
              <p>{t('Build')}</p>
              <p style={{ color: 'var(--text-token, #FFD600)' }}>
                {t('Furniture Factory')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ContractsLock };
